export const FETCH_AGREEMENT_API = '/agreements/:id';
export const FETCH_AGREEMENT_VERSION_API =
	'/panel/agreements/:agreement_id/versions/edit/:agreement_version_id';
export const FETCH_AGREEMENT_METADATA_API =
	'/panel/agreements/edit/:agreement_id/metadata';
